export default __webpack_public_path__ + "static/media/googleplay.24edc187.svg";